import { useDispatch, useSelector } from "react-redux";
import { IState } from "./interfaces/state";
import { ScrollArea } from "@radix-ui/react-scroll-area";
import { DraggableDialog } from "./components/DraggableDialog";
import { Button } from "./components/ui/button";
import { BasketActions, SearchActions, SettingsActions } from "./sagas/actions";




export const State = () => {

    const dispatch = useDispatch();
    const searchState: IState = useSelector((state: any) => state.search);
    const query = useSelector((state: any) => state.search.query);
    const showStatus = useSelector((state: any) => state.settings.showStatus);

    const handleHideStatus = () => {
        dispatch({ type: SettingsActions.TOGGLE_SHOW_STATUS })
    }
    const handleClearState = () => {
        dispatch({ type: SearchActions.CLEAR_STATE });
    }
    const handleDevAdd = () => {
        const id = prompt('Enter identifier to add to basket', 'h.b.0bmg');
        if (id) {
            dispatch({ type: BasketActions.ADD_TO_BASKET, payload: { identifier: id } });
        }
    }

    return (
        <DraggableDialog
            isOpen={showStatus}
            onClose={handleHideStatus}
            title="Redux State Viewer"
            width="32rem"
            height="calc(100vh - 150px)"
            initialPosition={{ x: 100, y: 100 }}
        >
            <div className="space-y-4">
                {/* Action buttons */}
                <div className="flex gap-2 pb-4 border-b border-gray-200">
                    <Button
                        variant="outline"
                        onClick={handleClearState}
                        className="flex-1"
                    >
                        Clear Query
                    </Button>
                    <Button
                        variant="outline"
                        onClick={handleDevAdd}
                        className="flex-1"
                    >
                        Dev Add to Basket
                    </Button>
                </div>

                {/* State content */}
                <ScrollArea className="h-[calc(100vh-300px)] text-sm">
                    <div className="space-y-4">
                        <div>
                            <h4 className="font-semibold text-gray-700 mb-2">Query:</h4>
                            <pre className="bg-gray-50 p-3 rounded-md overflow-x-auto text-xs">
                                {JSON.stringify(query, null, 2)}
                            </pre>
                        </div>
                        <div>
                            <h4 className="font-semibold text-gray-700 mb-2">State:</h4>
                            <pre className="bg-gray-50 p-3 rounded-md overflow-x-auto text-xs">
                                {JSON.stringify(searchState, null, 2)}
                            </pre>
                        </div>
                    </div>
                </ScrollArea>
            </div>
        </DraggableDialog>
    )
}

